var rich_content_viewer_default = {
  "fontElementMap": "w5qKU",
  "wrapper": "I2nBU",
  "pluginContainerMobile": "C3eQv",
  "viewer": "MF64R",
  "android": "K6x-8",
  "rootedTraversedContent": "Q-7Ms",
  "atomic": "_7LLPW",
  "toolbar": "kv-z8",
  "block": "jOFBn"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
